/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarCancelledIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarCancelledIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarCancelledIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarCancelledIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 10"
 style={{'--as-1-60wWi': alignSelf,'--mt-2-60wWi': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-60wWi': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-60wWi': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-60wWi': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-60wWi': opacity,'--w-10-60wWi': typeof width === 'number' ? `${width}px` : width,'--h-11-60wWi': typeof height === 'number' ? `${height}px` : height,'--f-12-60wWi': fill,'--a-7-60wWi': isAnimated ? animation : "none",'--sd-8-60wWi': isAnimated ? strokeDashoffset : 0,'--sd-9-60wWi': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarCancelledIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.5 0c.394 0 .714.32.714.714v.715h3.572V.714a.714.714 0 111.428 0v.715h.715C9.52 1.429 10 1.909 10 2.5v6.429C10 9.52 9.52 10 8.929 10H1.07C.48 10 0 9.52 0 8.929V2.5c0-.592.48-1.071 1.071-1.071h.715V.714C1.786.32 2.106 0 2.5 0zM5 3.036c.296 0 .536.24.536.536v2.5a.536.536 0 11-1.072 0v-2.5c0-.296.24-.536.536-.536zm0 5.536a.714.714 0 100-1.43.714.714 0 000 1.43z"
 style={{'--f-12-60wWi': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}